var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailtemplateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.640015L8.23 3.00001H5V5.00001L2.97 6.29001C2.39 6.64001 2 7.27001 2 8.00001V18C2 18.5304 2.21071 19.0392 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H20C21.11 20 22 19.11 22 18V8.00001C22 7.27001 21.61 6.64001 21.03 6.29001L19 5.00001V3.00001H15.77M7 5.00001H17V9.88001L12 13L7 9.88001M8 6.00001V7.50001H16V6.00001M5 7.38001V8.63001L4 8.00001M19 7.38001L20 8.00001L19 8.63001M8 8.50001V10H16V8.50001H8Z",
    fill: "#aa4f4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailtemplateIcon);
export default __webpack_public_path__ + "static/media/emailtemplate_icon.b3a8573a84474bc279becdf380a77d4e.svg";
export { ForwardRef as ReactComponent };